(() => {
  if (window.__novariaCartPageLoaded) return;
  window.__novariaCartPageLoaded = true;

  const money = (cents) =>
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0,
    }).format((Number(cents) || 0) / 100);

  const readConfig = () => {
    const node = document.getElementById('NovariaCartConfig');
    if (!node) return null;
    const d = node.dataset;
    return {
      heading: d.heading || 'Tu carrito',
      checkoutLabel: d.checkoutLabel || 'Finalizar compra',
      showSavings: d.showSavings !== 'false',
      showShipping: d.showShipping !== 'false',
      threshold: Math.max(0, Number(d.freeShippingThreshold) || 0),
      unlocked: d.freeShippingUnlocked || '¡Tienes envío gratis a todo Chile!',
      remaining: d.freeShippingRemaining || 'Te faltan [monto] para envío gratis',
      trust: [d.trust1 || 'Pago seguro', d.trust2 || 'Compra protegida', d.trust3 || 'Despacho a todo Chile'],
      showPayments: d.showPaymentLogos !== 'false',
    };
  };

  const setText = (node, text) => {
    if (node && node.textContent !== text) node.textContent = text;
  };

  const patch = () => {
    const cfg = readConfig();
    if (!cfg) return;

    document.querySelectorAll('[data-novaria-cart-page-heading]').forEach((node) => setText(node, cfg.heading));
    document.querySelectorAll('[data-novaria-cart-page-checkout-label]').forEach((node) => setText(node, cfg.checkoutLabel));
    document.querySelectorAll('[data-novaria-cart-page-saving], [data-novaria-cart-page-saving-summary]').forEach((node) => {
      node.hidden = !cfg.showSavings;
    });

    const reward = document.querySelector('[data-novaria-cart-page-shipping]');
    if (reward) {
      reward.hidden = !cfg.showShipping;
      if (cfg.showShipping) {
        const total = Math.max(0, Number(reward.dataset.cartTotal) || 0);
        const threshold = Math.round(cfg.threshold * 100);
        const unlocked = threshold <= 0 || total >= threshold;
        const remaining = Math.max(0, threshold - total);
        const progress = threshold <= 0 ? 100 : Math.min(100, Math.max(0, (total / threshold) * 100));
        const text = unlocked ? cfg.unlocked : cfg.remaining.replace('[monto]', money(remaining));
        reward.classList.toggle('is-unlocked', unlocked);
        setText(reward.querySelector('.novaria-cart-page__reward-text'), text);
        const check = reward.querySelector('.novaria-cart-page__reward-check');
        if (check) check.hidden = !unlocked;
        const fill = reward.querySelector('.novaria-cart-page__progress span');
        if (fill) fill.style.width = `${progress}%`;
      }
    }

    document.querySelectorAll('[data-novaria-cart-page-payments]').forEach((node) => {
      node.hidden = !cfg.showPayments;
    });
    cfg.trust.forEach((text, index) => {
      document.querySelectorAll(`[data-novaria-cart-page-trust="${index + 1}"]`).forEach((node) => setText(node, text));
    });
  };

  let frame = null;
  const schedule = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      patch();
    });
  };

  const observeRoot = (root) => {
    if (!root || root.dataset.novariaObserved === 'true') return;
    root.dataset.novariaObserved = 'true';
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  };

  const init = () => {
    observeRoot(document.querySelector('cart-items.novaria-cart-page'));
    observeRoot(document.getElementById('main-cart-footer'));
    schedule();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', schedule);
})();
